<template>
    <section class="bg-primary py-5 overflow-hidden" id="Intro">
        <div class="container flex flex-wrap py-5">
            <div class="row">
                <div class="col-12 text-white"><h3 class="text-title-content wow slideInDown">{{SectionIntro.title}}</h3></div>
                <div class="col-8 text-white text-content wow slideInLeft">
                    <p class="pt-5">{{SectionIntro.subtitle}}</p>
                    <ul class="white">
                        <li>{{SectionIntro.lists1}}</li>
                        <li>{{SectionIntro.lists2}}</li>
                        <li>{{SectionIntro.lists3}}</li>
                        <li>{{SectionIntro.lists4}}</li>
                    </ul>
                </div>
                <div class="col-4">
                    <div class="sun-icon animated pulse infinite" data-wow-delay="0.6s"></div>
                    <div class="col jargen3 wow slideInRight" data-wow-delay="0.1s"></div>
                    <div class="col jargen4 wow slideInRight" data-wow-delay="0.3s"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionIntro',

  data(){
   return{
     lastScrollPosition: 0,
     SectionIntro:{
         title: null,
         subtitle: null,
         lists1: null,
         lists2: null,
         lists3: null,
         lists4: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionIntro
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionIntro = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionIntro = response.data.en[0];
            }
            this.SectionIntro.title = dataSectionIntro.SectionIntro.title
            this.SectionIntro.subtitle = dataSectionIntro.SectionIntro.subtitle
            this.SectionIntro.lists1 = dataSectionIntro.SectionIntro.lists1
            this.SectionIntro.lists2 = dataSectionIntro.SectionIntro.lists2
            this.SectionIntro.lists3 = dataSectionIntro.SectionIntro.lists3
            this.SectionIntro.lists4 = dataSectionIntro.SectionIntro.lists4
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
